import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { Grid, TextField } from '@mui/material';
import { useIntl } from 'react-intl';
import { connectionsManageMessages as messages } from '../connections-manage-messages';

type Props = {
  /** Draft custom name for the connection (persisted on settings save). */
  name: string;
  onChange: (name: string) => void;
  /** Profile display name shown as the input placeholder when no custom name is set. */
  placeholder?: string;
};

/**
 * Optional custom label to distinguish connections that share a profile.
 * Persisted with the settings form via PATCH `/connections/:id` (`name`).
 */
export function ConnectionNameSettingsSection({ name, onChange, placeholder }: Props) {
  const { $t } = useIntl();

  return (
    <ContentCluster title={$t(messages.accountIdentification)}>
      <Grid container>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            fullWidth
            size="medium"
            value={name}
            onChange={(event) => onChange(event.target.value)}
            label={$t(messages.customName)}
            placeholder={placeholder}
            helperText={$t(messages.customNameHelper)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ maxLength: 100 }}
          />
        </Grid>
      </Grid>
    </ContentCluster>
  );
}
